export const BasicProgressSubTitle = [
  {
    text: "Progress components are built with two HTML elements, some CSS to set the width, and a few attributes. We use the ",
    code: ".progress ",
  },
  {
    text: "as a wrapper to indicate the max value of the progress bar. The ",
    code: ".progress-bar ",
  },
  {
    text: "requires an inline style, utility class, or custom CSS to set their width.",
  },
];

export const StripedProgressSubTitle = [
  {
    text: "Add ",
    code: ".progress-bar-striped",
  },
  {
    text: " to any ",
    code: ".progress-bar ",
  },
  {
    text: " to apply a stripe via CSS gradient over the progress bar's background color Using CSS Effects.",
  },
];

export const AnimetedProgressSubTitle = [
  {
    text: "The striped gradient can also be animated. Add ",
    code: ".progress-bar-animated",
  },
  {
    text: " to",
    code: ".progress-bar",
  },
  {
    text: " to animate the stripes right to left via CSS3 animations.",
  },
];

export const MultipleBarsSubTitle = [
  {
    text: "Include multiple progress bars in a progress component if you need.",
  },
];

export const ProgressNumberSubTitle = [
  {
    text: "Use the ",
    code: ".position-absolute ",
  },
  {
    text: "to set progress numbers steps.",
  },
];

export const CustomProgressSubTitle = [
  {
    text: "Use the ",
    code: ".progress-bar-animated ",
  },
  {
    text: "and ",
    code: ".progress-bar-striped ",
  },
  {
    text: "to animate the stripes right to left.",
  },
];

export const SmallProgressSubTitle = [
  {
    text: "Use ",
    code: " .sm-progress-bar",
  },
  {
    text: "  class to change progress size to small:",
  },
];

export const LargeProgressSubTitle = [
  {
    text: "Use ",
    code: " .lg-progress-bar",
  },
  {
    text: "  class to change progress size to large:",
  },
];

export const CustomSubTitle = [
  {
    text: "Set a height value on the ",
    code: ".progress-bar",
  },
  {
    text: ", so if you change that value the outer",
    code: ".progress",
  },
  {
    text: " will automatically resize accordingly.",
  },
];

export const BasicProgressData = [
  {
    class: "default",
    value: "0",
  },
  {
    class: "primary",
    value: "25",
  },
  {
    class: "secondary",
    value: "50",
  },
  {
    class: "success",
    value: "75",
  },
  {
    class: "info",
    value: "100",
  },
];

export const StripedProgressData = [
  {
    class: "primary",
    value: "10",
  },
  {
    class: "warning",
    value: "25",
  },
  {
    class: "danger",
    value: "50",
  },
  {
    class: "success",
    value: "75",
  },
];

export const MultipleBarData = [
  {
    data: [
      {
        class: "primary",
        value: "30",
      },
      {
        class: "secondary",
        value: "20",
      },
      {
        class: "success",
        value: "15",
      },
    ],
  },
  {
    data: [
      {
        class: "primary",
        value: "10",
      },
      {
        class: "secondary",
        value: "10",
      },
      {
        class: "success",
        value: "10",
      },
      {
        class: "info",
        value: "10",
      },
      {
        class: "warning",
        value: "10",
      },
      {
        class: "danger",
        value: "10",
      },
      {
        class: "primary",
        value: "10",
      },
      {
        class: "light",
        value: "10",
      },
    ],
  },
];

export const CustomProgressData = [
  {
    text: "0% Getting Started ",
    class: "default",
    value: "0",
  },
  {
    text: "30% Getting Uploading...",
    class: "primary",
    value: "30",
  },
  {
    text: "60% Getting Pause...",
    class: "secondary",
    value: "60",
  },
  {
    text: "70% Getting Uploading...",
    class: "success",
    value: "70",
  },
  {
    text: "100% Completed",
    class: "dark",
    value: "100",
  },
];

export const SmallProgressData = [
  {
    value: "30",
    text: "30 MB Data",
  },
  {
    value: "50",
    text: "50 MB Data",
  },
  {
    value: "75",
    text: "75 MB Data",
  },
  {
    value: "100",
    text: "100 MB Data",
  },
];

export const LargeProgressData = [
  {
    class: "primary",
    value: "25",
  },
  {
    class: "warning",
    value: "50",
  },
  {
    class: "secondary",
    value: "75",
  },
  {
    class: "info",
    value: "100",
  },
];

export const CustomHeightData = [
  {
    text: " 1px",
    class: "primary",
    value: "25",
  },
  {
    text: " 5px",
    class: "warning",
    value: "50",
  },
  {
    text: " 11px",
    class: "danger",
    value: "75",
  },
  {
    text: " 19px",
    class: "info",
    value: "100",
  },
];
